import {connect} from 'react-redux';
import {
  pollsSelector,
  userIdSelector,
} from '../../../reducers';
import Polls from './component';

const mapStateToProps = (state) => {
  const polls = pollsSelector(state);
  return {
    polls: (polls || {}),
    userId: userIdSelector(state),
  };
}

export default connect(mapStateToProps)(Polls);



// WEBPACK FOOTER //
// ./src/component/organisms/Polls/index.js